import config from '@/config/config.js';
import axios from 'axios'
import Cookies from 'js-cookie'
import API from './API.js'

export default class Connect extends API {
  //http://127.0.0.1:8001/api/connect/meetings/pre-requisite
  instance = axios.create({
    baseURL: config.serverConnectAPI,

  });

  route = 'meetings';

  Authorization = '';

  async GetAll(params) {
    const authorization = `Bearer ${Cookies.get('CONNECT_TOKEN')}`

    // console.log("api", params);
    const response = await this.instance.get(`/${this.route}`, { headers: { Authorization: authorization }, params })
    let { data } = response
    if (params) data = response.data.data
    if (this.imageFileds) this.addImagePath(data, this.imageFileds)

    return response.data
  }
  async preRequisite() {
    const authorization = `Bearer ${Cookies.get('CONNECT_TOKEN')}`
    // console.log("api", params);
    const response = await this.instance.get(`/meetings/pre-requisite`, { headers: { Authorization: authorization } })

    return response.data
  }

  async Show(id) {
    const response = await this.instance.get(`/${this.route}/${id}`)
    return response.data
  }

  async Insert(data, headers = {}) {
    const authorization = `Bearer ${Cookies.get('CONNECT_TOKEN')}`

    const response = await this.instance.post(`/${this.route}`, data, { headers: { Authorization: authorization } })
    return response.data
  }

  async Updata(data, headers = {}) {
    const authorization = `Bearer ${Cookies.get('CONNECT_TOKEN')}`


    try {
      const response = await this.instance.put(`/${this.route}/${data.uuid}`, data, { headers: { Authorization: authorization } })
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  async Delete(id, recordIds = []) {
    console.log(recordIds)
    const response = await this.instance.delete(`/${this.route}/${id}`, {
      data: { recordIds },
    })
    return response.data
  }
}
